import { jsx as r, jsxs as p } from "react/jsx-runtime";
import { useState as f } from "react";
import { ExpandMore as h } from "@mui/icons-material";
import { Accordion as x, Typography as y } from "@mui/material";
import A from "@mui/material/AccordionDetails";
import u from "@mui/material/AccordionSummary";
import n from "@mui/material/Box";
import { makeStyles as N } from "tss-react/mui";
import S from "./Accordion.style.js";
const g = N()(S), I = ({
  id: c,
  title: e,
  children: t,
  onExpandClick: a
}) => {
  const [m, i] = f(!1), { classes: o } = g(), l = (d) => (j, s) => {
    i(s ? d : !1), a && a(s);
  };
  return /* @__PURE__ */ r(n, { className: o.accordion, children: /* @__PURE__ */ p(
    x,
    {
      expanded: m === c,
      onChange: l(c),
      classes: {
        root: o.accordionItem
      },
      children: [
        /* @__PURE__ */ r(
          u,
          {
            expandIcon: /* @__PURE__ */ r(h, { className: o.expandIcon }),
            "aria-controls": e,
            id: c,
            className: o.accordionSummary,
            children: /* @__PURE__ */ r(n, { textAlign: "start", children: /* @__PURE__ */ r(y, { className: o.title, children: e }) })
          }
        ),
        /* @__PURE__ */ r(A, { className: o.accordionDetail, children: t })
      ]
    },
    c
  ) });
}, q = I;
export {
  I as Accordion,
  q as default
};
